<template>
    <div class="brief">
        <div class="row">
            <!-- 左边 -->
            <div class="fl w235">
                <div class="sideTitle2">
                    <div class="list-img">
                        <h5>备案管理</h5>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item,index) in list" :class="isActive == index?'active': ''" :key="index"
                                @click="listClick(item.id,index)">
                                <p>{{item.text}}</p>
                                <i class="el-icon-arrow-right"></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="sideImg">
                    <img src="../../assets/image/mxu.jpg" alt="">
                </div>
            </div>
            <!-- 右边 -->
            <div class="fr w750">
                <div class="pageBox2">
                    <div class="about">
                        <div class="border-all">
                            <div class="all-title">{{dataList.name}}</div>
                            <div class="all">
                                <!-- <div class="index-all">
                                    序号{{index+1}}
                                </div> -->
                                <div class="border-box">
                                    <div class="s-10 s-flex col-bottom">
                                        <div class="s-35 col-right text-center">单位名称</div>
                                        <div class="s-24 col-right text-center">统一社会信用代码</div>
                                        <div class="s-40 text-center">经营范围</div>
                                    </div>
                                    <div class="s-10 s-flex col-bottom">
                                        <div class="s-35 col-right text-center">
                                            {{dataList.name}}
                                        </div>
                                        <div class="s-24 col-right text-center">
                                            {{dataList.sn}}
                                        </div>
                                        <div class="s-40 text-center">
                                            {{dataList.businessScope}}
                                        </div>
                                    </div>
                                    <div class="s-10 s-flex col-bottom">
                                        <div class="s-1 col-right text-center">员工总数</div>
                                        <div class="s-35 col-right text-center" style="">经消毒知识与技能培训考试合格的人数</div>
                                        <div class="c-14 col-right text-center">信用评价等级</div>
                                        <div class="c-14 col-right text-center">主要检测项目</div>
                                        <div class="c-14 col-right text-center">消毒效果检测评价方式</div>
                                        <div class="c-12 text-center">备案时间</div>
                                    </div>
                                    <div class="s-10 s-flex col-bottom">
                                        <div class="s-1 col-right text-center">
                                            {{dataList.employees}}
                                        </div>
                                        <div class="s-35 col-right text-center">
                                            <div class="s-10 he text-center">
                                                <div class="s-71 he text-center col-right">消毒检测评价人员</div>
                                                <div class="s-28 he text-center">{{dataList.disinfectionInspector}}</div>
                                            </div>
                                        </div>
                                        <div class="c-14 col-right text-center">
                                            {{dataList.creditLevel}}
                                        </div>
                                        <div class="c-14 col-right text-center">
                                            {{dataList.businessForm}}
                                        </div>
                                        <div class="c-14 col-right text-center">
                                            {{dataList.evaluationMethod}}
                                        </div>
                                        <div class="c-12 text-center">
                                            {{dataList.recordTime}}
                                        </div>
                                    </div>
                                    <div class="s-10 s-flex">
                                        <div class="s-35 col-right s-flex">
                                            <div class="e-29 col-right text-center">单位地址</div>
                                            <div class="e-71-5 text-center">
                                                {{dataList.address}}
                                            </div>
                                        </div>
                                        <div class="s-24 col-right s-flex">
                                            <div class="e-41 col-right text-center">联系人</div>
                                            <div class="e-57 text-center">
                                                {{dataList.contact}}
                                            </div>
                                        </div>
                                        <div class="s-40 s-flex">
                                            <div class="e-42 col-right text-center">联系方式</div>
                                            <div class="e-78 text-center">
                                                {{dataList.contactPhone}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dataInformation: [],
                total: 0,
                isActive: 1,
                queryParams: {
                    pageNum: 1,
                    pageSize: 15,
                },
                list: [{
                        text: '消毒服务机构',
                        id: 1
                    },
                    {
                        text: '消毒检测评价机构备案公示名单',
                        id: 2
                    },{
                        text: '备案流程',
                        id: 3
                    },{
                        text: '产品备案',
                        id: 4
                    }
                ],
                dataList: {}
            }
        },
        mounted() {
            this.getlist();
        },
        methods: {
            getlist() {
                this.$axios.get('/websiteData/links/getOne/'+ this.$route.query.id).then(res => {
                    this.dataList = res.data.data;
                })
            },
            onClickDataNotice(id) {
                this.$router.push({
                    path: '/lay/neu',
                    query: {
                        id: id,
                        isActive: this.isActive,
                    }
                })
            },
            listClick(id) {
                if (id == 1) {
                    this.$router.push({
                        path: '/listOf',
                    })
                } else if (id == 2) {
                    this.$router.push({
                        path: '/publicityList',
                    })
                }else if (id == 3) {
                    this.$router.push({
                        path: '/filingProcess',
                    })
                }else if (id == 4) {
                    this.$router.push({
                        path: '/productFiling',
                    })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .brief {
        margin: 20px 0;
        overflow: hidden;

        .row {
            width: 1000px;
            background-color: #FFF;
            margin: 0 auto;

            .w235 {
                width: 235px;
                left: -8px;

                .sideImg {
                    text-align: center;
                    padding: 20px 0;
                }
            }

            .w750 {
                width: 750px;
                position: relative;
                right: -7px;

                .pageBox2 {
                    min-height: 830px;
                    border: 1px #DDDDDD solid;
                    border-radius: 5px;
                    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
                        0 0 6px 0 rgba(0, 0, 0, 0.04);

                    .about {
                        padding: 45px 35px;
                        font-size: 14px;
                        line-height: 20px;
                        text-align: justify;

                        ul {
                            li {
                                height: 41px;
                                line-height: 40px;
                                overflow: hidden;
                                position: relative;
                                background: url('../../assets/image/line.gif') bottom repeat-x;

                                a {
                                    background: url('../../assets/image/icons.gif') left center no-repeat;
                                    font-size: 14px;
                                    padding-left: 12px;
                                }

                                span {
                                    color: #999;
                                    position: absolute;
                                    top: 0px;
                                    right: 0px;
                                    white-space: nowrap;
                                }
                            }
                        }

                        .border-all {
                            padding: 10px 0;

                            .all-title {
                                text-align: center;
                                font-size: 18px;
                                font-weight: 700;
                            }

                            .all {
                                margin: 10px 10px;

                                .border-box {
                                    border: 2px solid #000;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .he{
        height: 100%;
    }
</style>